import React, {
    useState,
    useEffect,
    useCallback} from 'react';
import {getBlockMonths} from 'utils/getBlockMonths.js';
import {
    NUM_TRACKS,
    ADD_TRACKS,
    LOAD_TIME
} from './constants.js';

export const useMonths = ({
    setIsLoading,
    userWorks,
    setState,
}) => {
    let [currentMonth, setCurrentMonth] = useState(new Date().getMonth());
    let [months, setMonths] = useState({});
    useEffect(() => {
        getBlockMonths().then(
            x => setMonths(x));
    }, [setMonths]);


    const onClickMonth = useCallback((month) => {
        setIsLoading(true);
        let block = months[Math.min(new Date().getMonth(), month + 1)];
        if (month == new Date().getMonth()) {
            setState({numTracks: 25, scrollTop: 0});
            setCurrentMonth(month);
            setTimeout(() => {
                setIsLoading(false);
            }, 500);
            return;
        }

        for (let i in userWorks) {
            let _b = userWorks[i].blockNumber;
            if (_b < block) {
                let q = parseInt(i);
                setState({numTracks: q+NUM_TRACKS, skipTracks: q});
                setTimeout(() => {
                    setCurrentMonth(month);
                    setTimeout(() => {
                        setIsLoading(false);
                    }, 500);
                }, 50);
                break;
            }
        }
    }, [months, userWorks, setState, setCurrentMonth, setIsLoading]);

    return {onClickMonth, months, currentMonth, setCurrentMonth};
};
